import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {DateFormatPipe} from './pipe/format-date.pipe';
import {CommonModule, CurrencyPipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import {NotificationService} from '../service/notification.service';
import {I18nModule} from '../i18n/i18n.module';
import { SelectLanguageComponent } from './component/select-language/select-language.component';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import {CurrencyFormatPipe} from './pipe/currency-format.pipe';
import {ImageFormatPipe} from './pipe/image-format.pipe';
import {QRCodeModule} from 'angularx-qrcode';
import {OrderStatusFormatPipe} from './pipe/order-status-format.pipe';
import {FullNameFormatPipe} from './pipe/fullname-format.pipe';
import {NzPaginationModule} from 'ng-zorro-antd/pagination';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzCollapseModule} from 'ng-zorro-antd/collapse';
import {NzTableModule} from 'ng-zorro-antd/table';
import {InlineSVGModule} from 'ng-inline-svg';
import {FirstLetterPipe} from './pipe/first-letter.pipe';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzUploadModule} from 'ng-zorro-antd/upload';
import {MatTabsModule} from '@angular/material/tabs';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import { PhoneInputComponent } from './controls/phone-input/phone-input.component';
import { ProvinceSelectComponent } from './controls/province-select/province-select.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import { CountrySelectComponent } from './controls/country-select/country-select.component';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {NzAutocompleteModule} from 'ng-zorro-antd/auto-complete';
import {NgxBarcodeModule} from 'ngx-barcode';
import {NzRadioModule} from 'ng-zorro-antd/radio';
import {NzSwitchModule} from 'ng-zorro-antd/switch';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {AngularEditorModule} from '@kolkov/angular-editor';
import { TabDirective } from '../directive-tab/tab.directive';
import { EnterExeDirective } from '../directive-tab/enter-exe.directive';
import {PackingFormatPipe} from './pipe/packing-format.pipe';
import {ThousandsSeparatorDirective} from './directive/thousands-separator.directive';
import { VnCurrencyStringPipe } from './pipe/vn-currency-string.pipe';
import { MyDatePickerModule } from 'libs/mydatepicker/src/lib/mydatepicker.module';
import { NzImageModule } from 'ng-zorro-antd/image';
import { ClickOutsideDirective } from '../directive-tab/click-outside.directive';
import { MViewPdfComponent } from './component/m-view-pdf/m-view-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EnterTabDirective } from '../directive-tab/enter-tab.directive';
import {PersonFormatPipe} from './pipe/person-format.pipe';
import { GoogleMapService } from '../service/google-map.service';
import { ModalsModule } from './modals/modals.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NzTableModule,
    NzPaginationModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzModalModule,
    NzIconModule,
    NzLayoutModule,
    ScrollingModule,
    DragDropModule,
    NzCollapseModule,
    NzNotificationModule,
    I18nModule,
    NzFormModule,
    NzResultModule,
    NzTagModule,
    NzDropDownModule,
    NzMenuModule,
    NzDatePickerModule,
    ScrollingModule,
    QRCodeModule,
    InlineSVGModule,
    NzInputNumberModule,
    NzUploadModule,
    MatTabsModule,
    NzTabsModule,
    MatCheckboxModule,
    PerfectScrollbarModule,
    NzCheckboxModule,
    NzAutocompleteModule,
    NgxBarcodeModule,
    NzRadioModule,
    NzSwitchModule,
    NzCardModule,
    NzPopoverModule,
    NzToolTipModule,
    AngularEditorModule,
    MyDatePickerModule,
    NzImageModule,
    PdfViewerModule,
    ModalsModule
  ],
  exports: [
    PersonFormatPipe,
    DateFormatPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NzTableModule,
    NzPaginationModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzModalModule,
    NzIconModule,
    NzCollapseModule,
    NzNotificationModule,
    I18nModule,
    SelectLanguageComponent,
    NzFormModule,
    NzResultModule,
    NzTagModule,
    NzDropDownModule,
    NzMenuModule,
    NzDatePickerModule,
    ScrollingModule,
    DragDropModule,
    CurrencyFormatPipe,
    PackingFormatPipe,
    ImageFormatPipe,
    FullNameFormatPipe,
    OrderStatusFormatPipe,
    QRCodeModule,
    InlineSVGModule,
    FirstLetterPipe,
    NzInputNumberModule,
    NzUploadModule,
    MatTabsModule,
    NzTabsModule,
    PhoneInputComponent,
    ProvinceSelectComponent,
    CountrySelectComponent,
    MatCheckboxModule,
    PerfectScrollbarModule,
    NzCheckboxModule,
    NzAutocompleteModule,
    NgxBarcodeModule,
    NzRadioModule,
    NzSwitchModule,
    NzCardModule,
    NzPopoverModule,
    NzToolTipModule,
    AngularEditorModule,
    TabDirective,
    EnterTabDirective,
    EnterExeDirective,
    ThousandsSeparatorDirective,
    VnCurrencyStringPipe,
    MyDatePickerModule,
    NzImageModule,
    ClickOutsideDirective,
    MViewPdfComponent,
    PdfViewerModule,
    ModalsModule
  ],
  declarations: [
    PersonFormatPipe,
    DateFormatPipe,
    SelectLanguageComponent,
    CurrencyFormatPipe,
    PackingFormatPipe,
    ImageFormatPipe,
    FullNameFormatPipe,
    OrderStatusFormatPipe,
    FirstLetterPipe,
    PhoneInputComponent,
    ProvinceSelectComponent,
    CountrySelectComponent,
    TabDirective,
    EnterTabDirective,
    EnterExeDirective,
    ThousandsSeparatorDirective,
    ClickOutsideDirective,
    VnCurrencyStringPipe,
    MViewPdfComponent
  ],
  providers: [NotificationService, CurrencyPipe, DecimalPipe, GoogleMapService],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedModule { }
